import { ReactNode } from "react";
import classNames from "classnames";

import { Tag } from "../..";
import styles from "./FindBestPriceSelect.module.scss";

interface FindBestPriceSelect {
  label: string;
  inputData?: string;
  children?: ReactNode;
  drugType?: string;
  packaging?: string;
  inputHandler?: (name: string, option: string) => void;
  selected?: string;
  testId?: string;

}

const FindBestPriceSelect = (props: FindBestPriceSelect): JSX.Element => {
  const { label, drugType, inputData, packaging, children, inputHandler, selected, testId } = props;

  const inputClickHandler = (option: string) => {
    inputHandler && inputHandler(label, option);
  };

  let input = inputData;
  if (packaging) {
    input = `${inputData} ${packaging}`;
  }

  if (inputData) {
    return (
      <button
        type="button"
        onClick={() => inputClickHandler(inputData)}
        key={inputData}
        data-value={inputData}
        className={classNames(styles.FindBestPriceSelectOption, input === selected ? "selected-option" : "")}
        role="text"
        data-testid={testId}
      >
        {inputData}
        {drugType ? (
          <Tag
            className={drugType === "Brand" ? "brandTag" : ""}
            color={drugType === "Brand" ? "turquoise" : "darkgrey"}
            size="small">
            {drugType}
          </Tag>
        ) : null}
        {packaging ? ` ${packaging}` : ""}
      </button>
    );
  }
  if (children) {
    return <>{children}</>;
  }

  return <>null</>;
};

export default FindBestPriceSelect;
